import React, { useEffect, useRef, useState, forwardRef } from 'react';
import hall1 from '../../images/place/ueco_hall.jpg';
// import hall2 from '../../images/place/dcc_hall2.jpg';
import { IoIosArrowUp, IoIosArrowDown } from 'react-icons/io';
import { retrieveDngrEvalDtl, retrieveWrkDclrDtl } from '../../api/FnSmartTBM';
import { Tooltip } from "react-tooltip";
const $ = require("jquery")

export const SmrtTBMDngrEval = forwardRef<any, any>(({ doneTBM, agrd, setAgrd, mainDtlData, fldAgntDataList, wrkrInfoDataList, noneWrkDclr, sctrGb, evntSeq, selectedExbtPlcList,
  wrkDclrList, setReadWrkDclrList, setFldAgntDataList, setWrkrInfoDataList, setMainDtlData, setSelect, setSelectData, dngrEvalDataList, setDngrEvalDataList, setApprMemo, apprMemo }, dngrEvalRef) => {

  const inputRef = useRef<any>();
  const inputClick = () => { inputRef.current.click(); };
  const [viewInfo, setViewInfo] = useState(true);
  const [viewFldAgnt, setViewFldAgnt] = useState(true);
  const [viewRskFctr, setViewRskFctr] = useState(true);
  const [viewWrkrList, setViewWrkrList] = useState(true);
  const [viewMemo, setViewMemo] = useState(true);
  const [placeSrc, setPlaceSrc] = useState<string>(hall1);
  const mapRef = useRef<HTMLImageElement>(null);
  useEffect(() => {
    $("#smart-tbm-area").on("scroll", function () {
      if (mapRef && mapRef.current) {
        var width = mapRef.current.getBoundingClientRect().width
        var height = mapRef.current.getBoundingClientRect().height
        var maxCellXCount = 30
        var maxCellYCount = 30
        var stepCellXCount = width / maxCellXCount
        var stepCellYCount = height / maxCellYCount
        var points = $("[data-ge-place-point='true']")
        $.each(points, function (index: number, elem: any) {
          var x = $(elem).data("work-plc-x")
          var y = $(elem).data("work-plc-y")
          var left = stepCellXCount * x - (stepCellXCount / 2)
          var top = stepCellYCount * y - (stepCellYCount / 2)
          $(elem).css("display", "")
          $(elem).css("left", left)
          $(elem).css("top", top)
          //alert(width + " / " + height + " / " + left + " / " + top)
        })
      }
    })
    let wrkDclrSeq = 0;
    if (!noneWrkDclr) { wrkDclrSeq = wrkDclrList[0].wrkDclrSeq; }
    retrieveDngrEvalDtl({ wrkDclrSeq, noneWrkDclr, setFldAgntDataList, setWrkrInfoDataList, setMainDtlData, setDngrEvalDataList, setApprMemo, sctrGb, evntSeq });
  }, []);
  useEffect(() => {
    if (selectedExbtPlcList) {
      let plcNm = selectedExbtPlcList[0]
      if (plcNm === '전시장1') {
        setPlaceSrc(hall1)
      }
    } else if (mainDtlData) {
      var exbtPlcNm = mainDtlData.exbtPlcNm
      if (exbtPlcNm.indexOf("1") > -1) {
        setPlaceSrc(hall1)
      }
    }
  }, [mainDtlData])
  return (
    <div className='flex flex-col justify-center w-[260px] sm:w-[318px] md:w-[750px]' ref={dngrEvalRef}>
      <button onClick={() => setViewInfo(!viewInfo)} className='mt-24 flex justify-between items-center outline-none border-none w-full h-47 md:h-[117px] rounded-[5px] md:rounded-[12px] shadow-[0_0_3px_1px_rgba(0,0,0,0.10)]'>
        <div className='flex flex-col justify-center items-start pl-18 md:pl-[45px] w-[155px] sm:w-[210px] md:w-[525px] text-13 sm:text-15 md:text-37 font-preBold'>개요</div>
        {!viewInfo && <IoIosArrowDown className='mr-18 md:mr-[45px] md:w-[40px] md:h-[40px]' />}
        {viewInfo && <IoIosArrowUp className='mr-18 md:mr-[45px] md:w-[40px] md:h-[40px]' />}
      </button>
      {viewInfo &&
        <div className='flex mt-20 text-14 md:mt-[50px] md:text-35'>
          <div className='font-preBold'>
            <p className='ml-10 sm:ml-14 md:ml-[32px] mb-15 md:mb-[37px]'>행사명</p>
            {!noneWrkDclr && <p className='ml-10 sm:ml-14 md:ml-[32px] mb-15 md:mb-[37px] mr-20 md:mr-[40px]'>참가업체명</p>}
            {!noneWrkDclr && <p className='ml-10 sm:ml-14 md:ml-[32px] mb-15 md:mb-[37px]'>부스 번호</p>}
            {!noneWrkDclr && <p className='ml-10 sm:ml-14 md:ml-[32px] mb-15 md:mb-[37px]'>부스 수</p>}
            {!noneWrkDclr && <p className='ml-10 sm:ml-14 md:ml-[32px] mb-15 md:mb-[37px]'>부스 형태</p>}
            <p className='ml-10 sm:ml-14 md:ml-[32px] mb-15 md:mb-[37px]'>장소</p>
            <p className='ml-10 sm:ml-14 md:ml-[32px] mb-15 md:mb-[37px]'>준비기간</p>
            <p className='ml-10 sm:ml-14 md:ml-[32px]'>철거기간</p>
          </div>
          <div className='font-preLight w-[70%]'>
            <p className='mb-15 ml-10 md:mb-[37px] md:ml-[25px] truncate'>{mainDtlData?.evntNm}</p>
            {!noneWrkDclr && <p className='ml-10 mb-15 md:mb-[37px] md:ml-[25px]'>{mainDtlData?.ptcptCmpnyNm}</p>}
            {!noneWrkDclr && <p className='ml-10 mb-15 md:mb-[37px] md:ml-[25px]'>{mainDtlData?.bthNos}</p>}
            {!noneWrkDclr && <p className='ml-10 mb-15 md:mb-[37px] md:ml-[25px]'>{mainDtlData?.bthCnt === 0 ? '-' : mainDtlData?.bthCnt}</p>}
            {!noneWrkDclr && <p className='ml-10 mb-15 md:mb-[37px] md:ml-[25px]'>{mainDtlData?.bthTpNm}</p>}
            <p className='ml-10 mb-15 md:mb-[37px] md:ml-[25px]'>{mainDtlData?.exbtPlcNm}</p>
            <div className='flex ml-10 items-center mb-15 md:mb-[37px] md:ml-[25px]'><p>{mainDtlData?.cnstrStrtDt}</p><p className='mx-4 md:mx-[10px]'>~</p><p>{mainDtlData?.cnstrEndDt}</p></div>
            <div className='flex ml-10 items-center md:ml-[25px]'><p>{mainDtlData?.dmlnStrtDt}</p><p className='mx-4 md:mx-[10px]'>~</p><p>{mainDtlData?.dmlnEndDt}</p></div>
          </div>
        </div>
      }
      {!noneWrkDclr && <button onClick={() => setViewFldAgnt(!viewFldAgnt)} className='mt-24 md:mt-[60px] flex justify-between items-center outline-none border-none w-full h-47 md:h-[117px] rounded-[5px] md:rounded-[12px] shadow-[0_0_3px_1px_rgba(0,0,0,0.10)]'>
        <div className='flex flex-col justify-center items-start pl-18 md:pl-[45px] w-[155px] sm:w-[210px] md:w-[525px] text-13 sm:text-15 md:text-37 font-preBold'>현장 대리인</div>
        {!viewFldAgnt && <IoIosArrowDown className='mr-18 md:mr-[45px] md:w-[40px] md:h-[40px]' />}
        {viewFldAgnt && <IoIosArrowUp className='mr-18 md:mr-[45px] md:w-[40px] md:h-[40px]' />}
      </button>}
      {!noneWrkDclr && viewFldAgnt &&
        <table className='table-fixed w-[265px] sm:w-[318px] md:w-[750px] overflow-auto mt-24 md:mt-[60px]'>
          <tbody>
            <tr className='bg-[#F6F7F9] h-45 md:h-[112px] text-12 sm:text-13 md:text-32 leading-15 md:leading-[37px] border border-x-0 border-[#CACACA]'>
              <td className='align-middle text-center w-60 sm:w-80 md:w-[200px]'>성명</td>
              <td className='align-middle text-center w-40 sm:w-65 md:w-[162px]'>직책</td>
              <td className='align-middle text-center w-90 sm:w-110 md:w-[275px]'>휴대폰번호</td>
            </tr>
            {fldAgntDataList.map((agnt: any, idx: number) => {
              return (
                <tr key={idx} className='h-54 md:h-[135px] text-12 sm:text-14 md:text-35 leading-17 md:leading-[42px] font-preLight border border-x-0 border-t-0 border-[#CACACA]'>
                  <td className='align-middle text-center truncate'>{agnt.name}</td>
                  <td className='align-middle text-center truncate'>{agnt.position}</td>
                  <td className='align-middle text-center'>{agnt.phone}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      }
      <button onClick={() => setViewRskFctr(!viewRskFctr)} className='mt-24 md:mt-[60px] flex justify-between items-center outline-none border-none w-full h-47 md:h-[117px] rounded-[5px] md:rounded-[12px] shadow-[0_0_3px_1px_rgba(0,0,0,0.10)]'>
        <div className='flex flex-col justify-center items-start pl-18 md:pl-[45px] w-[155px] sm:w-[210px] md:w-[525px] text-13 sm:text-15 md:text-37 font-preBold'>위험요인 확인</div>
        {!viewRskFctr && <IoIosArrowDown className='mr-18 md:mr-[45px] md:w-[40px] md:h-[40px]' />}
        {viewRskFctr && <IoIosArrowUp className='mr-18 md:mr-[45px] md:w-[40px] md:h-[40px]' />}
      </button>
      {viewRskFctr && <>

        {dngrEvalDataList.map((data: any) => {
          return (
            <table key={data.seq} className='table-fixed w-full overflow-auto mt-24 md:mt-[60px]'>
              <tbody>
                <tr className='h-36 md:h-[90px] border border-x-0 border-[#CACACA]'>
                  <td colSpan={3} className='bg-[#F6F6F8] align-middle text-center text-13 leading-15 md:text-32 md:leading-37'>세부작업</td>
                  <td colSpan={13} className='pl-10 md:pl-[25px] font-preLight text-14 leading-16 md:text-35 md:leading-40'>{data.dtlWrk}</td>
                </tr>
                <tr className='h-36 md:h-[90px] border border-x-0 border-[#CACACA]'>
                  <td colSpan={3} className='bg-[#F6F6F8] align-middle text-center text-13 leading-15 md:text-32 md:leading-37'>위험요인</td>
                  <td colSpan={13} className='pl-10 md:pl-[25px] font-preLight text-14 leading-16 md:text-35 md:leading-40'>{data.dngrRsn}</td>
                </tr>
                {/*{!noneWrkDclr &&*/}
                <tr className='h-36 md:h-[90px] text-14 leading-16 md:text-35 md:leading-40 border border-x-0 border-t-0 border-[#CACACA]'>
                  <td colSpan={3} className='bg-[#F6F6F8] align-middle text-center text-13 leading-15 md:text-32 md:leading-37'>빈도</td>
                  <td colSpan={2} className='text-center font-preLight text-14 leading-16 md:text-35 md:leading-40'>{data.dngrFrqncy}</td>
                  <td colSpan={3} className='bg-[#F6F6F8] align-middle text-center text-13 leading-15 md:text-32 md:leading-37'>강도</td>
                  <td colSpan={2} className='text-center font-preLight text-14 leading-16 md:text-35 md:leading-40'>{data.dngrIntnsty}</td>
                  <td colSpan={3} className='bg-[#F6F6F8] align-middle text-center text-13 leading-15 md:text-32 md:leading-37'>위험도</td>
                  <td colSpan={3}
                    className={data.dngrScor === 9 ? 'bg-[#FFEEEF] text-[#EA505E] text-center font-preLight text-14 leading-16 md:text-35 md:leading-40'
                      : data.dngrScor <= 6 && data.dngrScor >= 4 ? 'text-[#FFB237] bg-[#FFFAE0] text-center font-preLight text-14 leading-16 md:text-35 md:leading-40'
                        : 'text-[#5DB202] bg-[#F4FBE9] text-center font-preLight text-14 leading-16 md:text-35 md:leading-40'}>
                    {data.dngrScor}{data.dngrScor === 9 ? '(높음)' : data.dngrScor <= 6 && data.dngrScor >= 4 ? '(보통)' : '(낮음)'}
                  </td>
                </tr>
                {/*}*/}
                <tr className='h-36 md:h-[90px] border border-x-0 border-[#CACACA]'>
                  <td colSpan={3} className='bg-[#F6F6F8] align-middle text-center text-13 leading-15 md:text-32 md:leading-37'>감소대책</td>
                  <td colSpan={13} className='pl-10 md:pl-[25px] font-preLight text-14 leading-16 md:text-35 md:leading-40'>{data.rdctMsr}</td>
                </tr>
              </tbody>
            </table>
          )
        })}

        <table className='table-fixed w-[265px] sm:w-[318px] md:w-[750px] overflow-auto mt-24 md:mt-[60px]'>
          <tbody>
            <tr className='bg-[#F6F7F9] h-36 md:h-[90px] text-12 sm:text-13 md:text-32 leading-15 md:leading-37 border border-x-0 border-[#CACACA]'>
              <td className='align-middle text-center'>작업장소</td>
            </tr>
            <tr className='border border-x-0 border-t-0 border-[#CACACA]'>
              <td className='algin-middle text-center relative'>
                <img ref={mapRef} className='object-cover' src={placeSrc} alt='map' data-ge-place-image="true" />
                {dngrEvalDataList.map((data: any, i1: number) => {
                  if (data.workPlc) {
                    var arr = eval(data.workPlc)
                    return <React.Fragment key={i1}>
                      {arr.map((point: any, i2: number) =>
                        <div key={i2}
                          data-tooltip-id="tooltip"
                          data-tooltip-content={data.dtlWrk + '(위험도:' + (data.dngrScor === 9 ? '높음' : data.dngrScor <= 6 && data.dngrScor >= 4 ? '보통' : '낮음') + ')'}
                          className='ge-mark-01' data-work-plc-x={point[0]} data-work-plc-y={point[1]} data-ge-place-point="true" style={{ display: "none" }} />
                      )}
                      <Tooltip id="tooltip" />
                    </React.Fragment>
                  }
                })}
              </td>
            </tr>
          </tbody>
        </table>
      </>}
      {!noneWrkDclr && <button onClick={() => setViewWrkrList(!viewWrkrList)} className='mt-24 md:mt-[60px] flex justify-between items-center outline-none border-none w-full h-47 md:h-[117px] rounded-[5px] md:rounded-[12px] shadow-[0_0_3px_1px_rgba(0,0,0,0.10)]'>
        <div className='flex flex-col justify-center items-start pl-18 md:pl-[45px] w-[155px] sm:w-[210px] md:w-[525px] text-13 sm:text-15 md:text-37 font-preBold'>작업자 명단</div>
        {!viewWrkrList && <IoIosArrowDown className='mr-18 md:mr-[45px] md:w-[40px] md:h-[40px]' />}
        {viewWrkrList && <IoIosArrowUp className='mr-18 md:mr-[45px] md:w-[40px] md:h-[40px]' />}
      </button>}
      {!noneWrkDclr && viewWrkrList &&
        <table className='table-fixed w-[265px] sm:w-[318px] md:w-[750px] overflow-auto mt-24 md:mt-[60px]'>
          <tbody>
            <tr className='bg-[#F6F7F9] h-45 md:h-[112px] text-12 sm:text-13 md:text-32 leading-15 md:leading-37 border border-x-0 border-[#CACACA]'>
              <td className='align-middle text-center w-30 sm:w-50 md:w-[125px]'>No</td>
              <td className='align-middle text-center w-70 sm:w-95 md:w-[237px] '>성명</td>
              <td className='align-middle text-center w-90 sm:w-115 md:w-[287px] '>휴대폰번호</td>
            </tr>
            {wrkrInfoDataList.length === 0 ?
                <tr className='h-54 md:h-[135px] text-12 sm:text-14 md:text-35 leading-17 md:leading-42 font-preLight border border-x-0 border-t-0 border-[#CACACA]'>
                  <td colSpan={3} className='align-middle text-center'>등록된 작업자가 없습니다.</td>
                </tr>
            : wrkrInfoDataList.map((wrkr: any, idx: number) => {
              return (
                <tr key={idx} className='h-54 md:h-[135px] text-12 sm:text-14 md:text-35 leading-17 md:leading-42 font-preLight border border-x-0 border-t-0 border-[#CACACA]'>
                  <td className='align-middle text-center'>{idx + 1}</td>
                  <td className='align-middle text-center truncate'>{wrkr.name}</td>
                  <td className='align-middle text-center'>{wrkr.phone}</td>
                </tr>
              );
            })}

          </tbody>
        </table>
      }
      {!noneWrkDclr && <button onClick={() => setViewMemo(!viewMemo)} className='mt-24 md:mt-[60px] flex justify-between items-center outline-none border-none w-full h-47 md:h-[117px] rounded-[5px] md:rounded-[12px] shadow-[0_0_3px_1px_rgba(0,0,0,0.10)]'>
        <div className='flex flex-col justify-center items-start pl-18 md:pl-[54px] w-[155px] sm:w-[210px] md:w-[525px] text-13 sm:text-15 md:text-37 font-preBold'>메모</div>
        {!viewMemo && <IoIosArrowDown className='mr-18 md:mr-[45px] md:w-[40px] md:h-[40px]' />}
        {viewMemo && <IoIosArrowUp className='mr-18 md:mr-[45px] md:w-[40px] md:h-[40px]' />}
      </button>}
      {!noneWrkDclr && viewMemo &&
        <div className='mt-23 md:mt-[57px] bg-[#F6F6F8] w-full h-100 md:h-[250px] overflow-auto scrollbar-hide px-9 py-9 md:px-[22px] md:py-[22px] text-14 leading-16 md:text-35 md:leading-40 rounded-[5px] md:rounded-[12px]'>{apprMemo}</div>
      }
      {/*{!doneTBM && <div className='flex w-full mt-11 md:mt-[27px]'>*/}
      {/*  {!agrd[1] ? <input ref={inputRef} onChange={() => setAgrd((prevState: any) => ({ ...prevState, 1: !agrd[1] }))} type='checkbox' className='accent-point md:w-[40px]' />*/}
      {/*    : <input ref={inputRef} onChange={() => setAgrd((prevState: any) => ({ ...prevState, 1: !agrd[1] }))} type='checkbox' className='accent-point md:w-[40px]' defaultChecked />}*/}
      {/*  <p onClick={inputClick} className='ml-10 md:ml-[25px] text-[#9C9C9B] text-13 leading-15 md:text-32 md:leading-37 font-preLight underline underline-offset-1 decoration-[#9C9C9B] decoration-[0.5px]'>모든 위험요인을 확인하고, 숙지하였습니다.</p>*/}
      {/*</div>}*/}
    </div>
  );
});
